import { render, staticRenderFns } from "./ParagraphStructure.vue?vue&type=template&id=8bd51b12&"
import script from "./ParagraphStructure.vue?vue&type=script&lang=js&"
export * from "./ParagraphStructure.vue?vue&type=script&lang=js&"
import style0 from "./ParagraphStructure.vue?vue&type=style&index=0&id=8bd51b12&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports